import { useMutation } from "react-query";
import { useIvideon } from "./useIvideon";
import { AcceptCameraIProps } from "../model/schema";

export default function useAcceptCamera() {
  const { acceptCamera } = useIvideon();
  const mutation = useMutation({
    mutationFn: (data: AcceptCameraIProps) => acceptCamera(data),
  });
  return { ...mutation, acceptCamera: mutation.mutateAsync };
}
